if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
        //  this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
       // console.log(selectedOptionValues);
        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(target,productUrl),
        });  
      }

      resetProductFormState() {
        const productForm = this.productForm;
     //   console.log('my product form is ' , productForm);
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
          //    console.log('Fetch aborted by user');
            } else {
         //     console.error(error);
            }
          });
      }

// ---------- helpers (put inside your class or hoist above it) ----------
norm(s) {
  return String(s ?? "")
    .normalize("NFKC")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Read currently-checked swatch values from THIS component's DOM.
 * Returns: { "Frame Color": "Tortoise Shell with Gold", "Lens Color": "Clear" }
 */
getSelectedByOptionName() {
  const map = {};
  // Scope to this component so we don't collide with other products on the page
  const sets = this.querySelectorAll('fieldset.product-form__input.product-form__input--swatch');

  sets.forEach((fs) => {
    // Legend like "Frame Color:" -> take text before the colon
    const legend = fs.querySelector('legend.form__label');
    if (!legend) return;

    const rawName = legend.childNodes[0]?.nodeValue || legend.textContent || "";
    const optionName = this.norm(String(rawName).split(':')[0]);

    // The checked input inside this fieldset
    const checked = fs.querySelector('.swatch-input__input:checked');
    if (!checked) return;

    const value =
      checked.value ??
      checked.getAttribute('data-value') ??
      checked.dataset?.value ??
      checked.getAttribute('aria-label') ??
      "";

    map[optionName] = this.norm(value);
  });

  return map;
}

/**
 * Parse the product JSON from the HTML fragment you passed into handleUpdateProductInfo.
 */
getProductFromHtml(html) {
  const el = html.querySelector('script[type="application/json"][data-selected-variant]');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error("Failed parsing product JSON", e);
    return null;
  }
}

/**
 * Exact match first (order-aware using product.options), then (optional) order-agnostic fallback.
 */
autoSwap(target) {
  // console.log('running autoswap');
  if (target) {
    var SelectedValue = target.value;
    var SelectedOption = target.name.split('-')[0].trim();
  //  console.log('my selected value is ' + SelectedValue + ' and my selected option is ' + SelectedOption);
      // we need to pick the next best option here:
      // Get the UL
var ul = document.getElementById("dekstech-available-variants");

// Split the option headers into an array
var optionHeaders = ul.dataset.option1.split(",").map(o => o.trim());

// Find the index of the selected option
var optionIndex = optionHeaders.indexOf(SelectedOption);

// Now loop through the LI elements and check the correct position
var lis = ul.querySelectorAll("li.dekstech-variant-possible");

function selectVariantFromLi(li) {
  const ul = document.getElementById('dekstech-available-variants');
  if (!ul || !li) return;

  // 1) Option headers order (e.g., ["Frame Color", "Lens Color"])
  const optionHeaders = ul.dataset.option1
    .split(',')
    .map(s => s.trim());

  // 2) Values for that variant (e.g., ["Tortoise Shell with Gold", "Clear"])
  const variantValues = li.dataset.variantOptions
    .split('/')
    .map(s => s.trim());

  // Helper: find the fieldset where legend text before ":" equals the option name
  const findFieldsetByLabel = (label) => {
    const fieldsets = document.querySelectorAll('variant-selects fieldset.product-form__input');
    for (const fs of fieldsets) {
      const legend = fs.querySelector('.form__label');
      if (!legend) continue;
      const legendLabel = (legend.childNodes[0]?.textContent || legend.textContent || '')
        .split(':')[0]
        .trim();
      if (legendLabel === label) return fs;
    }
    return null;
  };

  // 3) Click each option in order
  optionHeaders.forEach((optName, idx) => {
    const desiredValue = variantValues[idx];
    const fieldset = findFieldsetByLabel(optName);
    if (!fieldset) return;

    // Find the radio with the matching value (whitespace-safe)
    const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    const radio = radios.find(r => (r.value || '').trim() === desiredValue);
   // console.log(radio);
    if (radio) {
      // Prefer clicking the input (triggers native/change handlers). If needed, click its label.
      if (!radio.checked) {
        try {
          radio.prop('checked',true);
        } catch {
          const label = fieldset.querySelector(`label[for="${radio.id}"]`);
          if (label) label.click();
        }
      }
    } else {
      // Fallback: try matching by label title text
      const label = Array.from(fieldset.querySelectorAll('label.swatch-input__label'))
        .find(l => (l.getAttribute('title') || l.textContent || '').trim() === desiredValue);
      if (label) label.click();
    }
  });
}

// Usage after your match:
lis.forEach(li => {
  const optionIndex = optionHeaders.indexOf(SelectedOption);
  const opts = li.dataset.variantOptions.split('/').map(o => o.trim());
  if (opts[optionIndex] === SelectedValue) {
  //  console.log('Match found:', li);
    selectVariantFromLi(li);
  }
});

  }
}
getSelectedVariant(html) {
  const product = this.getProductFromHtml(html);
  var target = target;
  if (!product) return null;
  const selectedByName = this.getSelectedByOptionName();
// console.log(selectedByName);
  const optionOrder = product.options || []; // e.g., ["Frame Color","Lens Color"]

  // Build selections in backend order
  const orderedSelections = optionOrder.map((name) => this.norm(selectedByName[name]));
  const need = optionOrder.length;
  const have = orderedSelections.filter(Boolean).length;
  // console.log('my need is ' + need + ' and my have is ' + have);
  if (have !== need) return null; // not all options chosen yet

  // 1) Strict order-aware match
  const exact = (product.variants || []).find((v) => {
    const vOpts = [v.option1, v.option2, v.option3].filter((x) => x != null).map(this.norm);
    if (vOpts.length !== need) return false;
    for (let i = 0; i < need; i++) {
      if (vOpts[i] !== orderedSelections[i]) return false;
    }
    return true;
  });
  // console.log('this is my exact match ' + exact);
  if (exact) return exact;

  // 2) Order-agnostic fallback (handles any weird front-end order issues)
  const collator = new Intl.Collator(undefined, { sensitivity: "base" });
  const key = orderedSelections.slice().sort(collator.compare).join(" / ");
 
  for (const v of product.variants || []) {
    const sorted = [v.option1, v.option2, v.option3]
      .filter(Boolean)
      .map(this.norm)
      .sort(collator.compare)
      .join(" / ");
    if (sorted === key) { console.log(matched); return v;
    }
  }
  return null;
}


      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
       console.log('the url i am seeking is ' + `${url}?${params.join('&')}`);
            return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(target,productUrl) {
        return (html) => {
          let variant = this.getSelectedVariant(html);
            // lets get all the options selected and try to find variant in variant array
          if (variant) {
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant.id);
          this.updateVariantInputs(variant.id);
          }
          if (!variant || variant === null) {
            console.log("Variant is null or undefined");
            $('.product-restore-email').hide();
            $('.product-form__submit').removeAttr('dekstech-custom');
              console.log('trying to run autoswap before');
          this.autoSwap(target);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
            return;
          }
 console.log('trying to update rest');
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

const isDisabled =
  html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true;
console.log('my isDisabled value is ' + isDisabled);
// Update the button state + label
this.productForm?.toggleSubmitButton(isDisabled, window.variantStrings.soldOut);

// Hide if sold out, show otherwise
if (isDisabled) {
$('.product-form__submit').attr('dekstech-custom','disabled');
$('.product-restore-email').show();
} else {
$('.product-form__submit').removeAttr('dekstech-custom');
$('.product-restore-email').hide();
}
                    var handle = window.location.href;
        if (handle.indexOf('my-eye-gems-gift') === -1) {
          console.log('trying to update media');
            this.updateMedia(html, variant?.id);
        }
          publish(PUB_SUB_EVENTS.variantChange, {
            data: { 
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        
        this.querySelectorAll(
          `#product-form-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );
        if (this.dataset.updateUrl === 'false') return;
        console.log('trying to update link history and then will do checkboxes');
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);

const checkboxes = document.querySelectorAll('.maintenance-check');
const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
const form = document.querySelector('.product-form form');
const quantityInput = document.querySelector('.custom-quantity__input');

if (anyChecked) {
  console.log('i think something is checked');
  addMaintenancePlanFields(variantId);
}
else {
console.log('nothing checked');
}
 function addMaintenancePlanFields(variantId) {
  variantId = variantId.toString();
  console.log('Adding/updating maintenance plan fields…');

  let maintenanceVariantId = getMaintenanceVariantId();

  // --- ID FIELD ---
  let idField = document.getElementById("maintenance-plan-id");
  if (!idField) {
    idField = createHiddenInput("items[][id]", maintenanceVariantId);
    idField.id = "maintenance-plan-id";
    form.appendChild(idField);
  } else {
    idField.value = maintenanceVariantId; // just update
  }

  // --- QTY FIELD ---
  let qtyField = document.getElementById("maintenance-plan-qty");
  if (!qtyField) {
    qtyField = createHiddenInput("items[][quantity]", quantityInput.value);
    qtyField.id = "maintenance-plan-qty";
    form.appendChild(qtyField);
  } else {
    qtyField.value = quantityInput.value; // update
  }

  // --- PROPERTIES FIELD ---
  let propField = document.getElementById("maintenance-plan-prop-title");

  let variantProdCombo = "";
  $('.variant-list').each(function () {
    const thisVariant = $(this).attr('variant-id');
    if (thisVariant === variantId) {
      variantProdCombo = $(this).attr('variant-title');
    }
  });

  if (!propField) {
    propField = createHiddenInput("items[][properties][Linked Product]", variantProdCombo);
    propField.id = "maintenance-plan-prop-title";
    form.appendChild(propField);
  } else {
    propField.value = variantProdCombo; // update if exists
  }
}
          // Function to remove Maintenance Plan fields from form
  function removeMaintenancePlanFields() {
    document.querySelectorAll("#maintenance-plan-id, #maintenance-plan-qty, #maintenance-plan-prop-title")
      .forEach(input => input.remove());
  }
          // Function to get the correct Maintenance Plan Variant ID
  // Function to get the correct Maintenance Plan Variant ID
  function getMaintenanceVariantId() {
    let productPrice = parseInt(
      document.querySelector(".price-item--regular").textContent.replace(/[^0-9]/g, ""),
      10
    );

    if (productPrice <= 50000) {
      return "46447318892803";
    } else if (productPrice > 50000 && productPrice <= 75000) {
      return "46447318925571";
    } else if (productPrice > 75000 && productPrice <= 150000) {
      return "46447318958339";
    } else if (productPrice > 150000 && productPrice < 179900) {
      return "46447318991107";
    } else {
      return "46447319023875";
    }
  }
          // Function to create hidden input fields dynamically
  function createHiddenInput(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }
        let alreadyHandlingThumbnailClick = false;
        let isManuallyUpdatingVariant = false;
function autoSelectAvailableVariant() {
  if (isManuallyUpdatingVariant) return;
  isManuallyUpdatingVariant = true;
  const swatchGroups = document.querySelectorAll('.product-form__input--swatch');
  const variantIdField = document.querySelector('.product-variant-id');

  swatchGroups.forEach(swatchGroup => {
    console.log('i am in swatch groups');
    const selected = swatchGroup.querySelector('input[type="radio"]:checked');

    if (!selected || selected.classList.contains('visually-disabled')) {
      console.log('not selected');
      const firstAvailable = swatchGroup.querySelector('input[type="radio"]:not(.visually-disabled)');

      if (firstAvailable) {
        console.log('first available');
        const label = swatchGroup.querySelector(`label[for="${firstAvailable.id}"]`);

        if (label) {
          console.log('label exists');
          label.click(); // Simulate user click
          firstAvailable.checked = true;

          if (variantIdField) {
            variantIdField.value = firstAvailable.value;
          }

          // Handle thumbnail re-click only once
          const activeThumbnail = document.querySelector('.thumbnail[aria-current="true"]');
          console.log('my thumbnail is ' + activeThumbnail.parent().attr('data-variant-id'));
          if (activeThumbnail && !alreadyHandlingThumbnailClick) {
            alreadyHandlingThumbnailClick = true;

            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
           // activeThumbnail.dispatchEvent(clickEvent);

            setTimeout(() => {
              alreadyHandlingThumbnailClick = false;
            }, 250);
          }
        }
        else {
          console.log('no label found');
        }
      }
      else {
        console.log('first not available');
      }
    }
  });
            console.log('my variant id is ' + `${variantId}`);
  var variant_j = `${variantId}`;
  $('.variant-metafield-table').each(function() {
    var metaVariant = $(this).attr('data-variant-id');
    if (variant_j === metaVariant) {
       $(this).show();
    }
    else {
      $(this).hide();
    }
  });
}
  //  autoSelectAvailableVariant(); 
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantId) {
        if (!variantId) return;
        console.log("update media with variant ID:", variantId);
        
        const mediaGalleryItems = this.querySelectorAll('media-gallery li');
        
        // First hide all items and remove active class from all thumbnails
        if (mediaGalleryItems) {
        mediaGalleryItems.forEach(item => {
          item.classList.remove('is-active');
        });
      }
        console.log('after removing item');
        // Also reset all thumbnails
        const allThumbnails = this.querySelectorAll('media-gallery .thumbnail-list__item');
        allThumbnails.forEach(thumb => {
         // thumb.style.display = 'none';
          thumb.classList.remove('is-active');
          const thumbnail = thumb.querySelector('.thumbnail');
          if (thumbnail) {
            thumbnail.removeAttribute('aria-current');
          }
        });
        
        // Find and activate the variant's featured media
        // First check for metafield images associated with this variant
        const variantMetafieldMedia = this.querySelectorAll(`media-gallery li.variant-slider-thumbnail[data-variant-id="${variantId}"]`);
        let hasMetafieldImages = false;

        if (variantMetafieldMedia && variantMetafieldMedia.length > 0) {
          hasMetafieldImages = true;
          // Show all metafield images for this variant
          variantMetafieldMedia.forEach((thumbnail, index) => {
            thumbnail.style.display = 'block';
            // Make the first one active (matching the liquid condition: variant.id == selected_variant.id && forloop.index == 1)
            if (index === 0) {
              thumbnail.classList.add('is-active');
              const thumbnailButton = thumbnail.querySelector('.thumbnail');
              if (thumbnailButton) {
                thumbnailButton.setAttribute('aria-current', 'true');
              }
            }
          });
          
        // If we have a main thumbnail slide, make sure it's visible and active if it's the first one
        const mainThumbnails = this.querySelectorAll(`media-gallery li.main-thumbnail-slide[data-variant-id="${variantId}"]`);
          if (mainThumbnails.length > 0) {
            // Only make the first one active, matching the liquid condition
            mainThumbnails.forEach((thumbnail, index) => {
              thumbnail.classList.remove('is-active');
              if (index === 0) {
                thumbnail.classList.add('is-active');
                const thumbnailButton = thumbnail.querySelector('.thumbnail');
                if (thumbnailButton) {
                  thumbnailButton.setAttribute('aria-current', 'true');
                }
              }
            });
          }
        } 


        
        // If no metafield images, fall back to the variant's featured media
        // Get the variant's featured media ID from the HTML
        const variant = this.getSelectedVariant(html);
        const featuredMediaId = variant?.featured_media?.id;
        
        // Show all variant thumbnails for this variant
                  const variantThumbnails = document.querySelectorAll(`media-gallery li.variant-thumbnail`);
                  variantThumbnails.forEach(item => {
  item.classList.remove('visible');
});
        const variantMediaList = document.querySelectorAll(`li.variant-thumbnail[data-variant-id="${variantId}"]`);
variantMediaList.forEach(item => {
  item.classList.add('visible');
});
        if (variantMediaList && variantMediaList.length > 0) {
          let hasSetActive = false;
          
        //  console.log('variant media list length is ' + variantMediaList.length);
          
          
          // Count media items for this variant
          let variantMediaCount = 0;
          // Get all cycle-through items and count media between featured images
          const cycleThroughItems = this.querySelectorAll('.cycle-through');
          
          // Track featured media IDs to identify boundaries
          const featuredMediaIds = [];
          variantThumbnails.forEach(item => {
            const mediaId = item.getAttribute('data-target');
            featuredMediaIds.push(mediaId);
          });


        //   console.log(cycleThroughItems);
          
          // Count items between featured images
          const stopHereElements = [];
          cycleThroughItems.forEach((item, index) => {
            if (item.classList.contains('stop-here')) {
              stopHereElements.push({
                index: index,
                mediaId: item.getAttribute('data-media-id')
              });
            }
          });

         const counts = {};

        for (let i = 0; i < stopHereElements.length; i++) {
          if (i < stopHereElements.length - 1) {
            const start = stopHereElements[i];
            const end = stopHereElements[i + 1];
            const count = end.index - start.index - 1;

            // Use the start mediaId as the key
            counts[start.mediaId] = count;
          } else {
            const start = stopHereElements[i];
            const end = cycleThroughItems.length;
            const count = end - start.index - 1;

            // Use the start mediaId as the key
            counts[start.mediaId] = count;
          }
         
        }

     //   console.log("Counts between stop-here elements (keyed by data-media-id):", counts);
     //   console.log("Featured media IDs:", featuredMediaId);

        if (counts[this.dataset.section + '-' + featuredMediaId] !== undefined) {
          variantMediaCount = counts[this.dataset.section + '-' + featuredMediaId];
        } else {
          variantMediaCount = 0;
        }


          // if (cycleTroughItemsMediaArray.find((mediaId) => mediaId.includes(`${this.dataset.section}-${featuredMediaId}`))) {
          //   variantMediaCount = 1;
          // }
          

          
          variantMediaList.forEach((thumbnail, index) => {
            
            // If this is the first one and we haven't set an active item yet, make it active
            if (!hasMetafieldImages && !hasSetActive && index === 0) {
              thumbnail.classList.add('is-active');
              const thumbnailButton = thumbnail.querySelector('.thumbnail');
              if (thumbnailButton) {
                thumbnailButton.setAttribute('aria-current', 'true');
              }
              hasSetActive = true;
              
              // Also find and activate the corresponding main media item
              const targetId = thumbnail.getAttribute('data-target');
              if (targetId) {
                const mainMediaItem = this.querySelector(`media-gallery li[data-media-id="${targetId}"]`);
                if (mainMediaItem) {
                  console.log('trying to display ' + targetId);
                  mainMediaItem.classList.add('is-active');
               //   mainMediaItem.style.display = 'block';
                }
              }
            }
          });
          
          // If we've set an active item from the variant thumbnails, mark that we have variant-specific media
          if (hasSetActive) {
            hasMetafieldImages = true; // This prevents fallback to regular media
          }
        }
        
        // Hide thumbnails not associated with this variant
        const otherVariantThumbnails = this.querySelectorAll(`media-gallery li.variant-slider-thumbnail:not([data-variant-id="${variantId}"])`);
        otherVariantThumbnails.forEach(thumbnail => {
          console.log('i am removing thumbnail for this variant ' + thumbnail.getAttribute('data-variant-id') + 'and my varaint Id is ' + variantId);
          thumbnail.style.display = 'none';
          thumbnail.classList.remove('is-active');
          const thumbnailButton = thumbnail.querySelector('.thumbnail');
          if (thumbnailButton) {
            thumbnail.removeAttribute('aria-current');
          }
        });

        // Set featured media as active in the media gallery
        const activeMedia = this.querySelector('media-gallery li.is-active');
        if (activeMedia) {
       //   console.log('active media is ' + activeMedia.id);
          const activeMediaId = activeMedia.getAttribute('data-media-id');
          if (activeMediaId) {
            this.querySelector(`media-gallery`)?.setActiveMedia?.(activeMediaId, true);
          }
        } else if (featuredMediaId) {
          // Fallback to featured media if no active media found
          this.querySelector(`media-gallery`)?.setActiveMedia?.(`${this.dataset.section}-${featuredMediaId}`, true);
        }
        // Update media modal
  const modalImg      = productModal?.querySelector('.product-media-modal__content img');
  const activeMediaEl = this.querySelector('media-gallery li.is-active img');
  if (modalImg && activeMediaEl) {
    modalImg.src = activeMediaEl.currentSrc || activeMediaEl.src;
  }
        
        // Render 360 spin block at the end
        const tags = this.querySelector('product-info')?.dataset?.tags || '';
        if (tags.indexOf('no 360') === -1) {
          // Check if we have cycle-through slides
          const cycleSlides = this.querySelectorAll('.cycle-through');
          if (cycleSlides.length > 0) {
            // Show all spin images
            cycleSlides.forEach(slide => {
              console.log('setting this to block');
          //    slide.style.display = 'block';
              // Ensure slide exists and has classList before removing class
              if (slide && slide.classList) {
                slide.classList.remove('is-active');
                // Force DOM update with small delay if needed
                setTimeout(() => {
                  // Double-check the class was actually removed
                  if (slide.classList.contains('is-active')) {
                    slide.classList.remove('is-active');
                  }
                }, 0);
              }
           //   console.log('my slide data media id is ' + featuredMediaId);
           //   console.log('my slide data media id is ' + slide.dataset.mediaId);

              if (slide.dataset.mediaId === featuredMediaId) {

                // slide.classList.add('is-active');
              }
            });

            // if (slide.)

            
            // Reset current slide to first one
            const currentSlide = Array.from(cycleSlides).findIndex(slide => slide.classList.contains('is-active'));
            if (currentSlide !== -1) {
              // Start the 360 spin cycle
              if (typeof window.startCycle === 'function') {
                window.startCycle();
              } else if (typeof startCycle === 'function') {
                startCycle();
              } else {
                // Fallback if startCycle isn't directly accessible
                setTimeout(() => {
                  const event = new Event('click');
                  document.getElementById('rotate')?.dispatchEvent(event);
                }, 500);
              }
            } else {
              // If no slide is active, make the first one active
              if (cycleSlides.length > 0) {
                cycleSlides[0].classList.add('is-active');
                // Start the 360 spin cycle
                if (typeof window.startCycle === 'function') {
                  window.startCycle();
                } else if (typeof startCycle === 'function') {
                  startCycle();
                } else {
                  setTimeout(() => {
                    const event = new Event('click');
                    document.getElementById('rotate')?.dispatchEvent(event);
                  }, 500);
                }
              }
            }
          }
        }
      }
  
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
    //    console.log('updating quantity');
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}









